import { IconButton } from "@mui/material";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import React from "react";
import * as style from "./DashboardSidePanel.module.scss";

interface MenuItem {
  id: string;
  label: string;
  shortLabel: string;
}

interface MenuGroup {
  title: string;
  items: MenuItem[];
}

interface CustomViewsMenuProps {
  isPanelOpen?: boolean;
  groups?: MenuGroup[];
  selectedItem?: string;
  onItemClick?: (itemId: string) => void;
  onPanelToggle?: (isOpen: boolean) => void;
}

// Mock data for groups
const mockGroups: MenuGroup[] = [
  {
    title: "Role Management",
    items: [
      {
        id: "appLevel",
        label: "Applications",
        shortLabel: "AL",
      },
      {
        id: "roleLevel",
        label: "Roles",
        shortLabel: "RL",
      },
      {
        id: "featureLevel",
        label: "Features",
        shortLabel: "FL",
      },
    ],
  },
];

const DashBoardSidePanel: React.FC<CustomViewsMenuProps> = ({
  isPanelOpen = true,
  groups,
  selectedItem = "appLevel",
  onItemClick = () => {},
  onPanelToggle = () => {},
}) => {
  const displayGroups = mockGroups;
  const scssClass = style as any;
  return (
    <div
      className={scssClass.panel}
      style={{ width: isPanelOpen ? "254px" : "auto" }}
    >
      <div
        className={scssClass.title}
        style={{ justifyContent: isPanelOpen ? "space-between" : "center" }}
      >
        {isPanelOpen ? <div>Views</div> : <></>}
        <IconButton
          sx={{ transform: "rotate(90deg)", padding: "4px" }}
          onClick={() => onPanelToggle(!isPanelOpen)}
        >
          {isPanelOpen ? (
            <UnfoldLessIcon fontSize="small" />
          ) : (
            <UnfoldMoreIcon fontSize="small" />
          )}
        </IconButton>
      </div>

      <div className={scssClass.groupsContainer}>
        {displayGroups && displayGroups.length > 0 ? (
          displayGroups.map((group, groupIndex) => (
            <div key={`group-${groupIndex}`}>
              {/* {isPanelOpen && (
                  <div className={scssClass.groupTitle}>{group.title}</div>
                )} */}

              {group.items &&
                group.items.map((item, itemIndex) => (
                  <div
                    key={`${item.id}-${itemIndex}`}
                    role="button"
                    tabIndex={0}
                    className={`${scssClass.options} ${selectedItem === item.id ? scssClass.active : ""}`}
                    onClick={() => onItemClick(item.id)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        onItemClick(item.id);
                      }
                    }}
                    title={!isPanelOpen ? item.label : undefined}
                  >
                    {isPanelOpen ? item.label : item.shortLabel}
                  </div>
                ))}
            </div>
          ))
        ) : (
          <div style={{ padding: "16px", textAlign: "center", color: "#999" }}>
            No items available
          </div>
        )}
      </div>
    </div>
  );
};

export default DashBoardSidePanel;
